import * as z from 'zod/v4'

import {type CommandValueFor, createNamespacedActionCreator} from '../defineAction'

const createAction = createNamespacedActionCreator('recording')

// `noteId` and `createNote` are mutually exclusive; the handler enforces it
// (a zod .refine would not survive z.toJSONSchema).
const start = createAction(
  'start',
  z
    .strictObject({
      noteId: z.string().optional(),
      createNote: z.strictObject({title: z.string().optional(), folderId: z.string().optional()}).optional()
    })
    .optional()
)

export const recordingActions = [start] as const

export const recordingDescriptions = {
  recording_start:
    'Start a new audio recording; any active recording is stopped and saved first. Records into the current note by default, an existing note when noteId is given, or a newly created note when createNote is given.'
} satisfies Record<CommandValueFor<typeof recordingActions>, string>
